import React from 'react';
import { useParams } from 'react-router-dom';

import BouncedEmailDetailsContainer from '@totem/components/administration/bouncedEmails/details/BouncedEmailDetailsContainer';
import BouncedEmailDetailsLayout, {
  BouncedEmailDetailsExtra,
} from '@totem/components/administration/bouncedEmails/details/BouncedEmailDetailsLayout';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const BouncedEmailDetailsPage = () => {
  const { email } = useParams();

  return (
    <BouncedEmailDetailsContainer email={email}>
      <ContentLayout>
        <IBCard
          isCovered
          title="Bounced Email"
          extra={<BouncedEmailDetailsExtra />}
        >
          <BouncedEmailDetailsLayout />
        </IBCard>
      </ContentLayout>
    </BouncedEmailDetailsContainer>
  );
};

export default BouncedEmailDetailsPage;
